<template>
    <svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.15969 7.08349C8.42073 7.34453 8.42073 7.76776 8.15969 8.0288L4.18863 11.9999L4.17741 11.9886L4.16729 11.9988L0.196233 8.0277C-0.0648073 7.76666 -0.0648073 7.34343 0.196233 7.08239L0.289341 6.98928C0.550382 6.72824 0.973613 6.72824 1.23465 6.98928L3.31136 9.06598L3.31136 0.878318C3.31136 0.393236 3.70459 -2.03296e-07 4.18967 -1.82093e-07C4.67475 -1.60889e-07 5.06799 0.393236 5.06799 0.878317L5.06799 9.02399L7.11143 6.98055C7.37247 6.7195 7.7957 6.7195 8.05675 6.98055L8.15969 7.08349Z" fill="#3572B9"/>
    </svg>
</template>

<script>
export default {
    name: 'attach-file-icon'
}
</script>